import { SVGProps, Ref, forwardRef } from 'react';

export const ShareWebOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="m8.06 6.58-1.074.25c-3.012.704-4.428 2.55-5.1 4.229 1.27-.66 2.891-1.284 4.673-1.43l1.489-.121L8.073 11c.01.647.036 1.095.083 1.414q.114-.06.26-.144c.28-.16.604-.36 1.005-.608l2.27-1.402c1.234-.763 2.003-1.244 2.488-1.671.418-.369.418-.516.417-.585v-.013c0-.07.002-.217-.417-.586-.485-.426-1.254-.907-2.489-1.67L9.42 4.333a37 37 0 0 0-1.003-.608 9 9 0 0 0-.261-.144c-.06.413-.083 1.005-.089 1.895zm-1.314 5.843c.073.649.213 1.076.48 1.34.562.555 1.352.067 2.93-.909l2.27-1.403c2.38-1.47 3.57-2.206 3.57-3.453s-1.19-1.982-3.57-3.453l-2.27-1.403c-1.578-.976-2.368-1.464-2.93-.909-.47.466-.547 1.435-.559 3.234-4.99 1.166-6.31 5.05-6.658 7.177-.092.558.547.877 1.015.559.973-.66 2.494-1.529 4.253-1.952a9 9 0 0 1 1.396-.226c.01.552.03 1.014.073 1.398"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ShareWebOutlinedSize16Glyph.displayName = 'ShareWebOutlinedSize16Glyph';
